






































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {Diagram} from '@/interfaces/diagrams';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import IconButton from '@c/controls/IconButton.vue';
import ToolbarToogleIconButton from '@c/toolbar/ToolbarToogleIconButton.vue';
import SimpleDialog from '@c/SimpleDialog.vue';

@Component({
  components: {
    SelectionList,
    IconButton,
    ToolbarToogleIconButton,
    SimpleDialog,
  },
})
export default class CompareDiagramButtonDiagram extends Vue {
  // Диалоговое окно для выбора диаграмм
  dialog = false;

  // Идентификаторы выбранных диаграмм
  selectedDiagramIds: string[] = [];

  // При открытии диалога сохраняем выбранные индентификаторы
  dialogSelectedDiagramIds: string[] = [];
  @Watch('dialog')
  onDialog(value: boolean) {
    if (value) this.dialogSelectedDiagramIds = [...this.selectedDiagramIds];
    else this.updateSelectBtnState();
  }

  // Модель кнопки выбора диаграмм
  selectDiagramBtnIndex: number | null = null;

  @Prop({required: false, default: false})
  disabled!: boolean;

  // Список диаграмм для сравнения
  @Prop({required: true})
  diagrams!: Diagram[];

  //Действия при выборе программных модулей
  onSelectDiagrams() {
    this.selectedDiagramIds = [...this.dialogSelectedDiagramIds];
    this.dialog = false;
    this.updateSelectBtnState();
    this.$emit('select', this.selectedDiagramIds);
    this.updateSelectBtnState();
  }

  btnActiveState = false;
  updateSelectBtnState() {
    this.btnActiveState = this.selectedDiagramIds.length > 0;
    this.selectDiagramBtnIndex = this.btnActiveState ? 0 : null;
  }
}
